module.exports = __webpack_public_path__ + "static/media/w (27).ea3ab75a.jpg";